import { FETCH_CU_SMELTER_ALL_TIME_BY_SMELTER_DATA } from '../../actions';

export default (state = {}, action) => {
	switch (action.type) {
		case FETCH_CU_SMELTER_ALL_TIME_BY_SMELTER_DATA:
			return action.payload;
		default:
			return state;
	}
};
